import React, { Component } from 'react';
import { withRouter } from 'react-router';

import classNames from 'classnames';
import { Grid } from 'components/grid';
import { GridContainer } from 'components/gridContainer';
import { ROUTES } from 'configs/routes/constants';
import { inject } from 'mobx-react';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import ContentBasePageFooter from './ContentBasePageFooter';
import ContentBasePageHeader from './ContentBasePageHeader';

import { uploadNotifySave } from '@hotmart/club-files-ui';

import './ContentBasePage.scss';

@inject((stores) => ({
  ContentListConceptToggle: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.ContentListConcept
  )
}))
@withRouter
class ContentBasePage extends Component {
  static Header = ContentBasePageHeader;
  static Footer = ContentBasePageFooter;

  static propTypes = {
    history: PropTypes.object,
    backHandler: PropTypes.func,
    cancelHandler: PropTypes.func,
    children: PropTypes.node,
    title: PropTypes.string,
    className: PropTypes.string
  };

  backHandler = () => {
    const { backHandler, history, ContentListConceptToggle, match } =
      this.props;

    const currentParams = new URLSearchParams(window.location.search);

    if (ContentListConceptToggle) {
      const { moduleId } = match.params;

      currentParams.set('moduleId', moduleId);
      currentParams.set('arrivedFrom', 'content');
    }

    backHandler
      ? backHandler()
      : history.push(`${ROUTES.CONTENT.LIST}?${currentParams.toString()}`);
  };

  render() {
    const { children, className } = this.props;
    const gridClass = classNames('content__base__page', className);

    return (
      <Grid block transparent noborder className={gridClass}>
        <GridContainer>
          {children && this.renderChildren(children)}
        </GridContainer>
      </Grid>
    );
  }

  renderChildren(children) {
    return React.Children.map(children, (child) => {
      if (child) {
        switch (child.type) {
          case ContentBasePageHeader:
            return this.renderHeader(child);
          case ContentBasePageFooter:
            return this.renderFooter(child);
          default:
            return child;
        }
      }
    });
  }

  renderHeader(child) {
    return React.cloneElement(child, {
      ...child.props,
      backHandler: this.backHandler
    });
  }

  renderFooter(child) {
    return React.cloneElement(child, {
      backHandler: this.backHandler,
      cancelHandler: this.cancelHandler,
      ...child.props
    });
  }

  cancelHandler = (event) => {
    const { cancelHandler } = this.props;

    uploadNotifySave(null);

    cancelHandler ? cancelHandler(event) : this.backHandler();
  };
}

export default ContentBasePage;
